export function systemVersionLabel(version: string | undefined) {
  const trimmed = version?.trim();
  const normalized = trimmed && trimmed.length > 0 ? trimmed : 'local';
  return {
    full: normalized,
    short: /^[0-9a-f]{40}$/i.test(normalized) ? normalized.slice(0, 8) : normalized,
  };
}
